/**
 * The keys fe-inv's own SDK instance kept its tokens under before INV-927, with the key prefix ''.
 * Left in place they would hold a past user's token until it expires.
 */
export const RETIRED_TOKEN_KEYS = [':accessToken', ':expiresAt', ':tenantId'] as const

/**
 * Removes the retired keys. Never throws: a getter, as reading the storage can throw where it is
 * blocked, and blocked storage holds nothing fe-inv could remove.
 */
export function removeRetiredTokenKeys(
  getStorage: () => Pick<Storage, 'removeItem'> = () => window.localStorage,
): void {
  try {
    const storage = getStorage()
    for (const key of RETIRED_TOKEN_KEYS) storage.removeItem(key)
  } catch {
    // blocked storage: nothing fe-inv could have kept there
  }
}
